/// <reference path="../../typings/browser.d.ts" />



namespace Application.Directives {
    'use strict';

    import IPaginatedList = Models.IPaginatedList;
    import FlexEvent = Models.FlexEvent;
    import IConsoleAlarm = Models.IConsoleAlarm;
    import Alarm = Models.Alarm;

    interface IAlarmsMap {
        [key: string]: IConsoleAlarm[];
    }

    interface IMoreAlarmsMap {
        [key: string]: boolean;
    }

    interface IAlarmsRealLengthMap {
        [key: string]: number;
    }

    interface IAlarmFilters {
        deviceNames: string;
        names: string;
        values: string;
        levels: string;
    }

    type AlarmType = 'active' | 'masked' | 'acknowledged';

    /**
     * Custom scope
     */
    export interface IAlarmDirectiveScopeDef {
        system: string;
    }

    let getTemplateHref: (alarm: Models.IConsoleAlarm) => string = (alarm: Models.IConsoleAlarm) => {
        return alarm.templateHref ? alarm.templateHref : alarm.deviceId;
    };

    /**
     * Factory callback type
     */
    declare type AlarmsDirectiveFactoryCb = ($rootScope: Services.IFlexSettings,
                                             $interval: ng.IIntervalService,
                                             $timeout: ng.ITimeoutService,
                                             $window: ng.IWindowService,
                                             $q: ng.IQService,
                                             $location: ng.ILocationService,
                                             stompService: Services.StompService,
                                             alarmsService: Services.AlarmsService,
                                             networkNodeTypeService: Services.NetworkNodeTypeService,
                                             modalService: ngModal.IModalService,
                                             notificationService: Services.NotificationService,
                                             userService: Services.UserService,
                                             flexCollectorService: Services.FlexCollectorService,
                                             timezoneService: Services.TimezoneService) => AlarmsDirective;


    /**
     * Custom scope
     */
    export interface IAlarmsDirectiveScope extends ng.IScope {
        toggleAlarmsConsole: ($event: ng.IAngularEvent) => void;
        subscriptionCreate: Services.IEventSubscription;
        subscriptionBulkConfirm: Services.IEventSubscription;
        subscriptionBulkConfirmAll: Services.IEventSubscription;
        toggleStickyConsole: () => void;
        isStickyConsole: () => boolean;
        isHiddenConsole: () => boolean;

        alarmsMap: IAlarmsMap;
        selectedAlarm: IConsoleAlarm;
        selectAlarm: (alarm: IConsoleAlarm) => void;
        typeDisplayed: AlarmType;
        confirmAllAlarms: () => void;
        selectAlarmTab: (type: string) => void;
        someCriticalUnacknowledged: boolean;
        criticalUnacknowledged: number;
        dataLoaded: boolean;

        deviceNameStateMap: Directives.IStateMap;
        lastValueStateMap: Directives.IStateMap;
        levelStateMap: Directives.IStateMap;
        nameStateMap: Directives.IStateMap;

        alarmSearch: string;
        probeLink: string;

        acknowledgeModalAlarm: (alarm: IConsoleAlarm, comment: string) => void;
        changeMask: (alarm: IConsoleAlarm) => void;
        getSeverityColor: (severity: number) => string;
        getSeverityText: (severity: number) => string;
        getType: (href: string) => string;

        expandAlarm: (index: number) => void;
        collapseAlarm: (index: number) => void;

        goToSpecifics: (selectedAlarm: IConsoleAlarm) => void;
        goToUrl: (selectedAlarm: IConsoleAlarm) => void;

        moreAlarms: () => void;
        moreDataLoaded: boolean;
        moreAlarmsMap: IMoreAlarmsMap;
        alarmBeingConfirmed: IConsoleAlarm;
        allAlarmsConfirming: boolean;
        alarmsLengthMap: IAlarmsRealLengthMap;

        notificationTimer: angular.IPromise<void>;
        watcherCriticalAlarmsNotificationsFreq: Function;

        showConfirmAllAlarms: boolean;

        displayAlarmValue: (alarm: IConsoleAlarm) => Models.AlarmLevelValue;
        filter: () => void;
        system: boolean;
        timezoneService: Services.TimezoneService;

        stompReconnect: Function;
        searching: boolean
    }

    /**
     * Bar directive
     */
    export class AlarmsDirective implements ng.IDirective {
        public static $name: string = "alarmsConsole";
        public static NUM_REQUESTS: number = 30;

        public static ACTIVE: AlarmType = 'active';
        public static MASKED: AlarmType = 'masked';
        public static ACK: AlarmType = 'acknowledged';

        public static LEVEL_CRITICAL_LOW: number = 0;
        public static LEVEL_CRITICAL_HIGH: number = 8;

        public alarmTypes = [AlarmsDirective.ACTIVE, AlarmsDirective.MASKED, AlarmsDirective.ACK];

        public link: (scope: IAlarmsDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/alarms-directive.html';

        public scope: IAlarmDirectiveScopeDef = {
            system: '=?',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): AlarmsDirectiveFactoryCb {
            let directive: AlarmsDirectiveFactoryCb = ($rootScope: Services.IFlexSettings,
                                                       $interval: ng.IIntervalService,
                                                       $timeout: ng.ITimeoutService,
                                                       $window: ng.IWindowService,
                                                       $q: ng.IQService,
                                                       $location: ng.ILocationService,
                                                       stompService: Services.StompService,
                                                       alarmsService: Services.AlarmsService,
                                                       networkNodeTypeService: Services.NetworkNodeTypeService,
                                                       modalService: ngModal.IModalService,
                                                       notificationService: Services.NotificationService,
                                                       userService: Services.UserService,
                                                       flexCollectorService: Services.FlexCollectorService,
                                                       timezoneService: Services.TimezoneService) => {
                return new AlarmsDirective($rootScope, $interval, $timeout, $window, $q, $location,
                                           stompService, alarmsService, networkNodeTypeService,
                                           modalService, notificationService, userService, flexCollectorService, timezoneService);
            };
            directive.$inject = ['$rootScope', '$interval', '$timeout', '$window', '$q', '$location',
                                 'stompService', 'alarmsService', 'networkNodeTypeService',
                                 'ModalService', 'notificationService', 'userService', 'flexCollectorService', 'timezoneService'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor(private $rootScope: Services.IFlexSettings,
                    private $interval: ng.IIntervalService,
                    private $timeout: ng.ITimeoutService,
                    private $window: ng.IWindowService,
                    private $q: ng.IQService,
                    private $location: ng.ILocationService,
                    private stompService: Services.StompService,
                    private alarmsService: Services.AlarmsService,
                    private networkNodeTypeService: Services.NetworkNodeTypeService,
                    private modalService: ngModal.IModalService,
                    private notificationService: Services.NotificationService,
                    private userService: Services.UserService,
                    private flexCollectorService: Services.FlexCollectorService,
                    private timezoneService: Services.TimezoneService) {

            AlarmsDirective.prototype.link = ($scope: IAlarmsDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                this.init($scope, element);

                $scope.expandAlarm = (index: number) => {
                    this.expandAlarm($scope, index);
                };

                $scope.collapseAlarm = (startIndex: number) => {
                    this.collapseAlarm($scope, startIndex);
                };

                $scope.selectAlarm = (alarm: IConsoleAlarm) => {
                    this.selectAlarm($scope, alarm);
                };

                $scope.confirmAllAlarms = () => {
                    this.confirmAllAlarms($scope);
                };

                $scope.acknowledgeModalAlarm = (alarm: IConsoleAlarm) => {
                    this.acknowledgeModalAlarm(alarm, $scope);
                };

                $scope.changeMask = (alarm: IConsoleAlarm) => {
                    alarmsService.maskAlarmConfigLevel(getTemplateHref(alarm), alarm.name, alarm.level, !alarm.masked, true);
                };

                $scope.getSeverityColor = (severity: number): string => {
                    return Alarm.getSeverityColor(severity);
                };

                $scope.getSeverityText = (severity: number): string => {
                    return Alarm.getSeverityText(severity);
                };

                $scope.getType = (href: string) => {
                    return Alarm.getType(href);
                };

                $scope.selectAlarmTab =  (type: AlarmType) => {
                    $scope.selectedAlarm = undefined;
                    $scope.typeDisplayed = type;
                };

                $scope.moreAlarms = () => {
                    this.moreAlarms($scope);
                };

                $scope.goToSpecifics = (selectedAlarm: IConsoleAlarm) => {
                    this.goToSpecifics(selectedAlarm);
                };

                $scope.goToUrl = (selectedAlarm: IConsoleAlarm) => {
                    this.goToUrl(selectedAlarm);
                };

                $scope.toggleAlarmsConsole = ($event: ng.IAngularEvent) => {
                    this.toggleAlarmsConsole($scope, $event);

                };

                $scope.toggleStickyConsole = () => {
                    this.toggleStickyConsole($scope.system);
                };

                $scope.isStickyConsole = () => {
                    return !$scope.system && $rootScope.alarmConsoleSticky;
                };

                $scope.isHiddenConsole = () => {
                    return $rootScope.alarmConsoleHidden && !$scope.system;
                };

                $scope.displayAlarmValue = (alarm: IConsoleAlarm) => {
                    let finalValue: Models.AlarmLevelValue = alarm.valueDisplay ? alarm.valueDisplay : alarm.lastValue;
                    if (alarm.name === 'bitrate' || alarm.name === 'inputBitrate') {
                        if (typeof alarm.lastValue === 'number') {
                            finalValue = Common.Utils.kibiHumanReadableBits(alarm.lastValue);
                        } else if (typeof alarm.lastValue === 'string') {
                            finalValue = Common.Utils.kibiHumanReadableBits(parseInt(alarm.lastValue, 10));
                        }
                    }

                    return finalValue;
                };

                $scope.filter = () => {
                    this.loadInitialAlarms($scope).then(() => {
                        this.launchScrollEvent(element, $scope);
                    });
                };

                $scope.$on('consoleHidden', (event: ng.IAngularEvent, data: boolean) => {
                    $scope.selectedAlarm = undefined;
                });
                $rootScope.$watch('alarmConsoleHidden', (newValue) => {
                    if (newValue) $scope.selectedAlarm = undefined;
                });
                $scope.$on('refreshAlarmsConsole', (event: ng.IAngularEvent, args: boolean) => {
                    this.initVariables($scope);
                    this.reloadAlarms($scope);
                });

                $scope.$on('$destroy', () => {
                    if ($scope.subscriptionCreate)
                        stompService.unregister($scope.subscriptionCreate);

                    if ($scope.subscriptionBulkConfirm)
                        stompService.unregister($scope.subscriptionBulkConfirm);

                    if ($scope.subscriptionBulkConfirmAll)
                        stompService.unregister($scope.subscriptionBulkConfirmAll);

                    if ($scope.notificationTimer)
                        $interval.cancel($scope.notificationTimer);

                    if ($scope.watcherCriticalAlarmsNotificationsFreq) {
                        $scope.watcherCriticalAlarmsNotificationsFreq();
                    }

                    if ($scope.stompReconnect) {
                        $scope.stompReconnect();
                    }

                    element.find('#alarm-overflow-container').unbind('scroll');
                    angular.element(this.$window).unbind('scroll');
                });

                $scope.watcherCriticalAlarmsNotificationsFreq =
                    $rootScope.$watch('settings.criticalAlarmsNotificationsFreq', (newValue: number, oldValue: number) => {
                        if (newValue !== undefined && newValue !== oldValue) {
                            if ($scope.notificationTimer)
                                $interval.cancel($scope.notificationTimer);

                            // this.initNotificationTimer($scope, $rootScope, $interval, notificationService, flexCollectorService);
                        }
                    });

                $scope.$watch('alarmSearch', (newValue: string, oldValue: string) => {
                    if (!$scope.searching) {
                        $scope.searching = true;
                        $timeout(() => {
                            $scope.filter();
                            $scope.searching = false;
                        }, 500);
                    }
                });
            };
        }

        private init($scope: IAlarmsDirectiveScope, element: JQuery) {
            this.initVariables($scope);
            this.initialLoad($scope, element);

            this.initSubscriptions($scope);

            this.$rootScope.alarmConsoleHidden = !this.$rootScope.settings.alarmConsoleSticky;
            this.$rootScope.alarmConsoleSticky = this.$rootScope.settings.alarmConsoleSticky;

            $scope.timezoneService = this.timezoneService;
        }

        private processMoreAlarms($scope: IAlarmsDirectiveScope, type: AlarmType, promised: IPaginatedList<FlexEvent>) {
            let newAlarms: IConsoleAlarm[] = [];
            $scope.moreAlarmsMap[type] = this.createCollapsedAlarms($scope, promised.elements, newAlarms);
            newAlarms.forEach((newAlarm: IConsoleAlarm) => {
                newAlarm = Alarm.burnish(newAlarm) as Models.IConsoleAlarm;
                $scope.alarmsMap[type].push(newAlarm);
            });
            this.countCriticalUnconfirmedAlarms($scope);
            $scope.moreDataLoaded = true;
            this.updateLength($scope, type);
        }

        private updateLengths($scope: IAlarmsDirectiveScope) {
            this.alarmTypes.forEach((type: AlarmType) => {
                this.updateLength($scope, type);
            });
        }

        private updateLength($scope: IAlarmsDirectiveScope, type: AlarmType) {
            $scope.alarmsLengthMap[type] = 0;
            if ($scope.alarmsMap && $scope.alarmsMap[type].length > 0)
                $scope.alarmsLengthMap[type] = $scope.alarmsMap[type].map((alarm: IConsoleAlarm) => {
                    return alarm.collapsed.length + 1;
                }).reduce((previous: number, current: number, index: number, array: number[]) => {
                    return previous + current;
                });
        }

        private toggleAlarmsConsole($scope: IAlarmsDirectiveScope, $event: angular.IAngularEvent) {
            if (!$scope.system) {
                $event.preventDefault();
                this.$timeout(() => {
                    if (!this.$rootScope.alarmConsoleHidden)
                        $scope.selectedAlarm = undefined;
                    this.$rootScope.alarmConsoleHidden = !this.$rootScope.alarmConsoleHidden;
                    angular.element(this.$window).resize();
                    angular.element(window).resize();
                    if (this.$location.path().indexOf('/monitoring-room') !== -1)
                        this.$rootScope.settings.alarmConsoleHiddenInMonitoring = this.$rootScope.alarmConsoleHidden;
                });
            }
        }

        private toggleStickyConsole(system: boolean) {
            if (!system) {
                this.$timeout(() => {
                    this.$rootScope.alarmConsoleSticky = !this.$rootScope.alarmConsoleSticky;
                    this.$rootScope.settings.alarmConsoleSticky = this.$rootScope.alarmConsoleSticky;
                });
            }
        }

        private confirmAllAlarms($scope: Application.Directives.IAlarmsDirectiveScope) {
            $scope.selectedAlarm = undefined;

            this.modalService
                .showModal({
                    templateUrl: Controllers.ConfirmModalController.templateURL,
                    controller: Controllers.ConfirmModalController.$name,
                    inputs: {
                        title: 'Confirm all alarms',
                        description: 'Every active alarm will be confirmed.',
                        name: '',
                        type: 'warning',
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement =
                        UIkit.modal(Controllers.ConfirmModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: Object) => {
                        modalElem.hide();
                        if (result) {
                            $scope.allAlarmsConfirming = true;
                            this.alarmsService.confirmEveryAlarm("No comment", $scope.system)
                                .then(() => {
                                    $scope.allAlarmsConfirming = false;
                                });
                        }
                    });
                });
        }

        private acknowledgeModalAlarm(alarm: Models.IConsoleAlarm, $scope: IAlarmsDirectiveScope) {
            let comment: string = "";
            this.modalService.showModal({
                templateUrl: Controllers.AcknowledgeModalController.templateURL,
                controller: Controllers.AcknowledgeModalController.$name,
                inputs: {
                    selectedAlarm: alarm,
                    comment: comment,
                    editMode: !alarm.confirmed,
                },
            }).then((modal: ngModal.IModalObject) => {
                let acknowledgeModalElem: UIkit.ModalElement = UIkit.modal(Controllers.AcknowledgeModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                acknowledgeModalElem.show();
                let initialSticky: boolean = $scope.isStickyConsole();
                if (!initialSticky) {
                    this.toggleStickyConsole($scope.system);
                }
                modal.close.then((result: string) => {
                    acknowledgeModalElem.hide();
                    if (result !== undefined) {
                        $scope.alarmBeingConfirmed = alarm;
                        this.confirmAlarm($scope, alarm, result, this.alarmsService)
                            .then(() => {
                                $scope.alarmBeingConfirmed = undefined;
                            });
                        $scope.selectedAlarm = undefined;
                    }
                });
            });
        }

        private expandAlarm($scope: IAlarmsDirectiveScope, index: number) {
            let alarm: IConsoleAlarm = $scope.alarmsMap[$scope.typeDisplayed][index];
            let elementsToExpand: IConsoleAlarm[] = alarm.collapsed;
            alarm.collapsed = [];
            let before: IConsoleAlarm[] = $scope.alarmsMap[$scope.typeDisplayed].slice(0, index);
            let after: IConsoleAlarm[] = $scope.alarmsMap[$scope.typeDisplayed].slice(index + 1);
            $scope.alarmsMap[$scope.typeDisplayed] = before.concat(alarm).concat(elementsToExpand).concat(after);
        }

        private collapseAlarm($scope:IAlarmsDirectiveScope, startIndex: number) {
            let endIndex: number = this.findCollapsableElementsFromIndex($scope.alarmsMap[$scope.typeDisplayed], startIndex);
            let before: IConsoleAlarm[] = $scope.alarmsMap[$scope.typeDisplayed].slice(0, startIndex);
            let alarm: IConsoleAlarm = $scope.alarmsMap[$scope.typeDisplayed][startIndex];
            let collapsedElements: IConsoleAlarm[] = [];
            if (endIndex > startIndex) {
                for (let i: number = startIndex + 1; i <= endIndex; i++) {
                    collapsedElements.push($scope.alarmsMap[$scope.typeDisplayed][i]);
                }
            }
            let after: IConsoleAlarm[] = $scope.alarmsMap[$scope.typeDisplayed].slice(endIndex + 1);
            alarm.collapsed = collapsedElements;
            $scope.alarmsMap[$scope.typeDisplayed] = before.concat(alarm).concat(after);
        }

        private selectAlarm($scope: IAlarmsDirectiveScope, alarm: Application.Models.IConsoleAlarm) {
            $scope.selectedAlarm = angular.equals($scope.selectedAlarm, alarm) ? undefined : alarm;
            if ($scope.selectedAlarm && $scope.selectedAlarm.relayedFrom && $scope.selectedAlarm.relayedFrom === 'TNS') {
                let tsProbeString: string = "tsProbe";
                let slotString: string = "slot";
                let tsProbe: string = $scope.selectedAlarm.extra[tsProbeString];
                let slot: number = +$scope.selectedAlarm.extra[slotString];
                $scope.probeLink = '#!/ts-probes/' + Common.Utils.idFromHref(tsProbe) + "/" + slot;
            }

            if ($scope.selectedAlarm) {
                this.alarmsService.canWriteEventId($scope.selectedAlarm.flexEventId).then((canWrite: boolean) => {
                    $scope.selectedAlarm.canWrite = canWrite;
                });
            }
        }

        private goToSpecifics(selectedAlarm: IConsoleAlarm) {
            let href: string = selectedAlarm.templateHref ? selectedAlarm.templateHref : selectedAlarm.deviceId;
            if (href)
                this.$location.path(selectedAlarm.deviceId.indexOf('flexServices') === 0 ?
                    '/admin/alarms/services/' + href : '/admin/alarms/specifics/' + href);
        }

        private moreAlarms($scope: IAlarmsDirectiveScope) {
            let type: AlarmType = $scope.typeDisplayed;
            if ($scope.moreAlarmsMap[type] && $scope.moreDataLoaded) {
                $scope.moreDataLoaded = false;
                const alarmFilters: IAlarmFilters = this.getAlarmFilters($scope);
                this.alarmsService.findAllByType(type,
                    AlarmsDirective.NUM_REQUESTS,
                    $scope.alarmsLengthMap[type],
                    $scope.system,
                    alarmFilters.deviceNames,
                    alarmFilters.names,
                    alarmFilters.values,
                    alarmFilters.levels,
                    $scope.alarmSearch)
                    .then((promised: IPaginatedList<FlexEvent>) => {
                        this.processMoreAlarms($scope, type, promised);
                    });
            }
        }

        private reloadAlarms($scope: IAlarmsDirectiveScope) {
            this.loadInitialAlarms($scope).then(() => {
                this.countCriticalUnconfirmedAlarms($scope);
            });
        }

        private initialLoad($scope: IAlarmsDirectiveScope, element: JQuery) {
            this.$timeout(() => {
                this.loadInitialAlarms($scope).then(() => {
                    this.countCriticalUnconfirmedAlarms($scope);
                    this.launchScrollEvent(element, $scope);
                });
            }, 1000);
        }

        private findCollapsableElementsFromIndex(array: IConsoleAlarm[], index: number): number {
            let endIndex: number = index + 1;
            let alarm: IConsoleAlarm = array[index];
            while (endIndex < array.length && this.canBeCollapsed(alarm, array[endIndex]))
                endIndex++;
            endIndex--;
            return endIndex;
        }

        private countCriticalUnconfirmedAlarms($scope: IAlarmsDirectiveScope): void {
            this.alarmsService.countCriticalFlexAlarms($scope.system).then((response: Models.ICriticalCountResponse) => {
                $scope.someCriticalUnacknowledged = response.some;
                $scope.criticalUnacknowledged = response.count;
            }).catch((reason: ngCustom.IReason) => {
                console.log(reason);
            });
        }

        private createConsoleAlarm(flexEvent: Models.IFlexEvent): IConsoleAlarm {
            let alarm: IConsoleAlarm = flexEvent.data as IConsoleAlarm;
            alarm.flexEventId = flexEvent.id;
            if (alarm && alarm.lastValue && typeof alarm.lastValue === 'number') {
                alarm.lastValue = Common.Utils.round(alarm.lastValue, 6);
            }
            this.networkNodeTypeService.findByHref(alarm.deviceType)
                .then((networkNodeType: Models.NetworkNodeType) => {
                    alarm.deviceTypeName = networkNodeType.name;
                });
            alarm.timestamp = new Date(flexEvent.timestamp);
            alarm.appearances = 1;
            alarm.collapsed = [];
            return alarm;
        }

        private removeAlarmFrom(alarm: IConsoleAlarm, alarms: IConsoleAlarm[]): void {
            let indexToDelete: number = -1;
            for (let i: number = 0; i < alarms.length; i++) {
                if (alarms[i].flexEventId === alarm.flexEventId)
                    indexToDelete = i;
            }

            if (indexToDelete !== -1) {
                let alarmToDelete: IConsoleAlarm = alarms[indexToDelete];
                let nextAlarm: IConsoleAlarm = alarms[indexToDelete + 1];
                let followingAlarm: IConsoleAlarm = alarms[indexToDelete + 2];
                let collapseToIndex: number = alarmToDelete.collapseTo;

                /**
                 * Check if the collapsable element is not collapsable anymore
                 */
                if (collapseToIndex !== -1) {
                    alarms[collapseToIndex].appearances--;
                    if (alarms[collapseToIndex].appearances === 1) {
                        alarms[collapseToIndex].collapsable = false;
                    }
                }

                /**
                 * Check if it's going to be deleted the collapsable element
                 */
                if (alarmToDelete.collapsable && nextAlarm !== undefined) {
                    nextAlarm.collapsable = followingAlarm !== undefined && this.canBeCollapsed(nextAlarm, followingAlarm);
                    nextAlarm.appearances = alarmToDelete.appearances - 1;
                    nextAlarm.collapseTo = -1;
                }

                alarms.splice(indexToDelete, 1 );
            }
        }

        private getNotificationText(criticalUnacknowledged: number): string {
            return "Total critical alarms: " + criticalUnacknowledged;
        }

        private getAlarmNotificationText(alarm: IConsoleAlarm, severity: string, criticalUnacknowledged: number): string {
            return "Device: " + alarm.deviceName + "\n" +
                "Alarm: " + alarm.name + " " + alarm.lastValue +
                " [" + severity + "]\n" +
                "Total critical alarms: " + criticalUnacknowledged;
        }

        private confirmAlarm($scope: IAlarmsDirectiveScope, alarm: IConsoleAlarm, comment: string,
                             alarmsService: Services.AlarmsService): ng.IPromise<Models.IFlexEvent> {
            if (alarm.collapsed.length > 0) {
                alarm.collapsed.forEach((collapsedAlarm: IConsoleAlarm) => {
                    alarmsService.confirmAlarm(collapsedAlarm.flexEventId, comment);
                });
            }
            return alarmsService.confirmAlarm(alarm.flexEventId, comment);
        };

        private addAlarm($scope: IAlarmsDirectiveScope, alarm: IConsoleAlarm): void {
            if (alarm.confirmed) {
                this.unshiftWithLimit($scope, alarm, $scope.alarmsMap[AlarmsDirective.ACK]);
            } else {
                let destination: IConsoleAlarm[] = alarm.masked ?
                    $scope.alarmsMap[AlarmsDirective.MASKED] : $scope.alarmsMap[AlarmsDirective.ACTIVE];
                if (destination.length > 0) {
                    let first: IConsoleAlarm = destination[0];
                    if (this.canBeCollapsed(alarm, first)) {
                        alarm.collapseTo = -1;
                        alarm.collapsable = true;
                        alarm.collapsed = [first].concat(first.collapsed);
                        alarm.appearances = first.appearances + 1;

                        first.collapsable = false;
                        first.collapseTo = 0;
                        first.collapsed = [];
                        first.appearances = 1;

                        destination.shift();
                    } else {
                        alarm.appearances = 1;
                        alarm.collapsable = false;
                        alarm.collapseTo = -1;
                    }
                } else {
                    alarm.collapsable = false;
                    alarm.collapseTo = -1;
                }
                this.unshiftWithLimit($scope, alarm, destination);
            }
        };

        private unshiftWithLimit($scope: IAlarmsDirectiveScope, alarm: IConsoleAlarm, destination: IConsoleAlarm[]): void {
            destination.unshift(alarm);
            this.updateLengths($scope);
        }

        private canBeCollapsed(alarm1: IConsoleAlarm, alarm2: IConsoleAlarm): boolean {
            return alarm1.deviceId === alarm2.deviceId &&
                   alarm1.level === alarm2.level &&
                   alarm1.name === alarm2.name &&
                   alarm1.deviceName === alarm2.deviceName &&
                   !alarm1.confirmed &&
                   !alarm2.confirmed;
        }

        private createCollapsedAlarms($scope: IAlarmsDirectiveScope, events: FlexEvent[], destination: IConsoleAlarm[]): boolean {
            let moreAlarms: boolean = events.length === AlarmsDirective.NUM_REQUESTS;
            events.forEach((event: FlexEvent, index: number) => {
                let alarm: IConsoleAlarm = this.createConsoleAlarm(event);
                alarm.collapseTo = -1;
                if (index === 0) {
                    destination.push(alarm);
                } else {
                    let indexToCompare: number = destination.length - 1;
                    let previousElement: IConsoleAlarm = destination[indexToCompare];
                    if (this.canBeCollapsed(previousElement, alarm)) {
                        alarm.collapseTo = indexToCompare;
                        previousElement.collapsed.push(alarm);
                        previousElement.collapsable = true;
                        previousElement.appearances++;
                    } else {
                        destination.push(alarm);
                    }
                }
            });
            return moreAlarms;
        }


        private loadInitialAlarms($scope: IAlarmsDirectiveScope): ng.IPromise<boolean> {
            $scope.dataLoaded = false;
            const alarmFilters: IAlarmFilters = this.getAlarmFilters($scope);
            let allPromises: ng.IPromise<IPaginatedList<FlexEvent>>[] = 
                this.alarmTypes.map((type: AlarmType) => {
                    return this.alarmsService.findAllByType(type, AlarmsDirective.NUM_REQUESTS, 0, $scope.system,
                        alarmFilters.deviceNames, alarmFilters.names, alarmFilters.values, alarmFilters.levels,
                        $scope.alarmSearch);
                });

            return this.$q.all(allPromises).then((alarmsLists: IPaginatedList<FlexEvent>[]) => {
                alarmsLists.forEach((alarmList: IPaginatedList<FlexEvent>, index: number) => {
                    let alarmType: AlarmType = this.alarmTypes[index];
                    $scope.alarmsMap[alarmType] = [];
                    $scope.moreAlarmsMap[alarmType] =
                        this.createCollapsedAlarms($scope, alarmList.elements, $scope.alarmsMap[alarmType]);
                });
                this.updateLengths($scope);
                return $scope.dataLoaded = true;
            });
        }

        private getAlarmFilters($scope: IAlarmsDirectiveScope): IAlarmFilters {
            return {
                deviceNames: $scope.deviceNameStateMap ? this.getFilteredValues($scope.deviceNameStateMap) : "",
                names: $scope.nameStateMap ? this.getFilteredValues($scope.nameStateMap) : "",
                values: $scope.lastValueStateMap  ? this.getFilteredValues($scope.lastValueStateMap) : "",
                levels: $scope.levelStateMap  ? this.getFilteredValues($scope.levelStateMap, true) : ""
            };
        }

        private getFilteredValues(map: IStateMap, isLevel = false): string {
            let enabledValues: string [] = Object.keys(map).filter((key: string) => map[key]);
            if (isLevel)
                enabledValues = enabledValues.map((value: string) =>
                    isLevel ? '' + Alarm.severityTexts.indexOf(value) : value
                );
            return enabledValues.join(', ');
        }

        private initNotificationTimer($scope: IAlarmsDirectiveScope, $rootScope: Services.IFlexSettings,
                                      $interval: ng.IIntervalService, notificationService: Services.NotificationService,
                                      flexCollectorService: Services.FlexCollectorService): void {
            if ($rootScope.settings.criticalAlarmsNotificationsFreq > 0) {
                $scope.notificationTimer = $interval(() => {
                    // FIXME: we are comparing the list of unconfirmed critical alarms with
                    // the device map reported by flex_collector, so we can check if an alarm
                    // is still on or not.
                    // This should be replaced by the new live database.
                    flexCollectorService.getAlarmsDeviceMap().then((map: Object) => {
                        let criticalUnconfirmedActive: number = 0;
                        $scope.alarmsMap[AlarmsDirective.ACTIVE].filter((alarm: IConsoleAlarm) => {
                            return Alarm.isCritical(alarm.level);
                        }).forEach((alarm: IConsoleAlarm) => {
                            if (map[alarm.deviceId] && map[alarm.deviceId].params &&
                                map[alarm.deviceId].params.length > 0) {

                                for (let param of map[alarm.deviceId].params) {
                                    if (param.name === alarm.name) {
                                        if (param.level === alarm.level)
                                            criticalUnconfirmedActive++;
                                        break;
                                    }
                                }
                            }
                        });

                        if (criticalUnconfirmedActive > 0) {
                            notificationService.showNotification(this.getNotificationText(criticalUnconfirmedActive));
                        }
                    });
                }, $rootScope.settings.criticalAlarmsNotificationsFreq * 60 * 1000);
            }
        }

        private initVariables($scope: IAlarmsDirectiveScope): void {
            $scope.dataLoaded = false;
            $scope.moreDataLoaded = true;
            $scope.alarmSearch = $scope.alarmSearch ? $scope.alarmSearch : "";
            $scope.typeDisplayed = AlarmsDirective.ACTIVE;
            $scope.alarmsMap = {};
            $scope.moreAlarmsMap = {};
            $scope.alarmsLengthMap = {};
            this.alarmTypes.forEach((alarmType: AlarmType) => {
                $scope.alarmsMap[alarmType] = [];
            });
            $scope.criticalUnacknowledged = $scope.criticalUnacknowledged ? $scope.criticalUnacknowledged : 0; 
            $scope.selectedAlarm = undefined;

            this.initFilterMaps($scope);

            this.userService.loadCurrentUser().then((user: Models.User) => {
                // Show "confirm all alarms" only if the user is admin
                $scope.showConfirmAllAlarms = user.authorities.some((auth: Models.IAuthority) => {
                    return auth.authority === 'ROLE_ADMIN';
                });
            });
            // to ask for permission to show notifications when app is loaded,
            // instead of when first notification is generated,
            // and only for users with permissions to see alarms
            this.notificationService.requestPermission();
        }

        private initSubscriptions($scope: IAlarmsDirectiveScope): void {
            $scope.subscriptionCreate = this.stompService.register(Models.ALARMS_COMPONENT, Models.CREATE_OPERATION,
                (flexEvent: Models.IFlexEvent) => {
                    this.newAlarm(flexEvent, $scope);
                });

            $scope.subscriptionBulkConfirm = this.stompService.register(Models.ALARMS_COMPONENT, Models.BULK_CONFIRM_OPERATION,
                (flexEvent: Models.IFlexEvent) => {
                    this.reloadAlarms($scope);
                });

            $scope.subscriptionBulkConfirmAll = this.stompService.register(Models.ALARMS_COMPONENT, Models.BULK_CONFIRM_ALL_OPERATION,
                (flexEvent: Models.IFlexEvent) => {
                    this.initVariables($scope);
                    this.reloadAlarms($scope);
                });

            $scope.stompReconnect = this.$rootScope.$on('stompReconnect', () => {
                this.initVariables($scope);
                this.reloadAlarms($scope);
            });
        }

        private async newAlarm(flexEvent: Models.IFlexEvent, $scope: IAlarmsDirectiveScope) {
            if (flexEvent.data.system === $scope.system) {
                if (await this.alarmsService.canReadEvent(flexEvent)) {
                    let alarm: IConsoleAlarm = this.createConsoleAlarm(flexEvent);

                    if (alarm.confirmed) {
                        const alarmMapKey: string = alarm.masked ? AlarmsDirective.MASKED : AlarmsDirective.ACTIVE;
                        this.removeAlarmFrom(alarm, $scope.alarmsMap[alarmMapKey]);
                    }

                    this.addAlarm($scope, alarm);

                    if (Alarm.isCritical(alarm.level)) {
                        if (!alarm.masked) {
                            this.incrementConsoleCounter($scope);
                        }
                        if (!alarm.confirmed) {
                            this.showAlarmNotification(alarm, Alarm.getSeverityText(alarm.level), $scope.criticalUnacknowledged);
                        }
                    }
                    this.addToFilters($scope, alarm);
                }
            }
        }

        private showAlarmNotification(alarm: Models.IConsoleAlarm, severity: string, count: number) {
            this.notificationService.showNotification(
                this.getAlarmNotificationText(alarm, severity, count));
        }

        private incrementConsoleCounter($scope: Directives.IAlarmsDirectiveScope) {
            if ($scope.criticalUnacknowledged > -1) {
                $scope.criticalUnacknowledged++;
            }
            $scope.someCriticalUnacknowledged = true;
        }

        private launchScrollEvent(element: JQuery, $scope: IAlarmsDirectiveScope): void {
            if ($scope.system) {
                angular.element(this.$window).on('scroll', (): void => {
                    if ($scope.moreAlarmsMap[$scope.typeDisplayed] && $scope.moreDataLoaded &&
                        (this.$window.innerHeight + this.$window.scrollY) >= document.body.scrollHeight) {
                        this.moreAlarms($scope);
                    }
                });
            } else {
                const container: JQuery = element.find('#alarm-overflow-container');
                container.on('scroll', () => {
                    if ($scope.moreAlarmsMap[$scope.typeDisplayed] && $scope.moreDataLoaded &&
                        (container.innerHeight() + container.scrollTop()) >= ($scope.alarmsMap[$scope.typeDisplayed].length * 25)) {
                        this.moreAlarms($scope)
                    }
                });
            }
        }

        private initFilterMaps($scope: IAlarmsDirectiveScope): void {
            this.initFilterMap('deviceName', $scope.system).then((map: IStateMap) => $scope.deviceNameStateMap = map);
            this.initFilterMap('nameDisplay', $scope.system).then((map: IStateMap) => $scope.nameStateMap = map);
            this.initFilterMap('lastValue', $scope.system).then((map: IStateMap) => $scope.lastValueStateMap = map);
            this.initFilterMap('level', $scope.system).then((map: IStateMap) => $scope.levelStateMap = map);
        }

        private async initFilterMap(field: string, system: boolean): Promise<IStateMap> {
            let map: IStateMap = {};
            const uniqueValues: string[] = await this.alarmsService.getUniqueFields(field, system);
            uniqueValues.forEach((uniqueValue: string) => {
                if (field === 'level') {
                    uniqueValue = Alarm.getSeverityText(+uniqueValue);
                }
                map[uniqueValue] = false
            });
            return map;
        }

        private addToFilters($scope: IAlarmsDirectiveScope, alarm: IConsoleAlarm): void {
            this.addToMap($scope.deviceNameStateMap, alarm.deviceName);
            this.addToMap($scope.nameStateMap, alarm.nameDisplay);
            this.addToMap($scope.lastValueStateMap, ''+alarm.lastValue);
            this.addToMap($scope.levelStateMap, Alarm.getSeverityText(alarm.level));
        }

        private addToMap(map: IStateMap, key: string): void {
            map[key] = map[key] !== undefined ? map[key] : false;
        }

        private goToUrl(selectedAlarm: IConsoleAlarm): void {
            if (selectedAlarm.link) {
                window.open(selectedAlarm.link, '_blank');
            }
        }
    }

    export function removeDupAlarmsFilter(): Object {
        return function(data: IConsoleAlarm[], enable: boolean): IConsoleAlarm[] {
            if (!enable) {
                return data;
            } else if (angular.isArray(data)) {
                let result: IConsoleAlarm[] = [];
                for (let i: number = data.length - 1; i >= 0; i--) {
                    let currentVal: IConsoleAlarm = data[i];
                    if (i === 0 || data.length === 1)
                        result.unshift(currentVal);
                    else {
                        let next: IConsoleAlarm = data[i - 1];
                        if ((currentVal.deviceId !== next.deviceId) ||
                            (currentVal.deviceId === next.deviceId && currentVal.appearances >= next.appearances)) {
                            result.unshift(currentVal);
                        }
                    }
                }
                return result;
            }
            return data;
        };
    }
}

